<template>
  <div v-if="!tabLoading" class="grid grid--rev">
    <div class="grid__cell col5-of-12--large-up"></div>
    <div class="grid__cell col7-of-12--large-up">
      <p class="fw-bold fs-md mb-sm">Current badges</p>
      <BadgeItem
        v-for="(badge, index) in items"
        @delete-item="removeItem"
        @update-item="updateItem"
        :key="index.id"
        :data="badge"
        :index="index"
      ></BadgeItem>
      <BadgeItem
        v-for="(badge, index) in newItems"
        @delete-item="removeNewItem"
        @update-item="updateNewItem"
        :key="index"
        :data="badge"
        :index="index"
      ></BadgeItem>
      <Button
        bType="secondary"
        class="mt-3"
        v-on:button-click="addNewItem(amount)"
      >
        Add new badge
        <!-- <i class="fa fa-plus ml-xs"></i> -->
      </Button>
    </div>
  </div>
</template>

<script>
import BadgeItem from '@/components/Dashboard/SettingsBadgesItem';
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/badges');

export default {
  components: {
    BadgeItem,
    Button,
  },
  computed: {
    ...mapGetters(['items', 'newItems']),
    amount() {
      if (this.items === undefined) {
        if (this.newItems === undefined) {
          return 0;
        }
        return this.newItems.length;
      } else {
        if (this.newItems === undefined) {
          return this.items.length;
        }
        return this.newItems.length + this.items.length;
      }
    },
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  methods: {
    ...mapActions([
      'fetchBadges',
      'addNewItem',
      'updateItem',
      'updateNewItem',
      'removeItem',
      'removeNewItem',
      'clearItems',
    ]),
  },
  created() {
    this.clearItems();
    // this.fetchBadges();
  },
};
</script>
